import { SelectionModel } from '@angular/cdk/collections';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatLegacyListOption as MatListOption } from '@angular/material/legacy-list';

@Component({
  standalone: false,
  selector: 'sbnb-property-detail-amenity-selection',
  templateUrl: './property-detail-amenity-selection.component.html',
  styleUrls: ['./property-detail-amenity-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyDetailAmenitySelectionComponent implements OnInit, OnChanges {
  @Input() amenities: string[];
  @Input() edited: boolean;
  @Input() hasAirbnbListing = true;
  @Input() availableAmenities: any[] = [];
  @Output() updated: EventEmitter<string[]> = new EventEmitter();

  label = 'Amenities';

  editMode = false;

  searchCriteria = '';

  // Flatten a list of amenities for quickly grabbing the labels from the keys.
  flattenedAmenities: {
    key: string;
    label: string;
    description: string;
  }[] = [];

  constructor() { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    this.flattenedAmenities = this.buildFlattenedAmenityKeyValue(this.availableAmenities);
  }

  buildFlattenedAmenityKeyValue(availableAmenities): { key: string; label: string; description: string }[] {
    let output = [];

    availableAmenities.forEach((category) => {
      output = output.concat(category.amenities);
    });

    return output;
  }

  setAmenities(selectedOptions: SelectionModel<MatListOption>) {
    this.amenities = selectedOptions.selected.map((x) => x.value);
    this.editMode = false;
    this.updated.emit(this.amenities);
  }
}
